/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurement } from './APIMeasurement';
import {
    APIMeasurementFromJSON,
    APIMeasurementFromJSONTyped,
    APIMeasurementToJSON,
} from './APIMeasurement';
import type { APIHumanReadableDuration } from './APIHumanReadableDuration';
import {
    APIHumanReadableDurationFromJSON,
    APIHumanReadableDurationFromJSONTyped,
    APIHumanReadableDurationToJSON,
} from './APIHumanReadableDuration';

/**
 * Special serializer that provides all data that should appear in an Article CSV Export.
 * @export
 * @interface APIArticleExport
 */
export interface APIArticleExport {
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly number: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly articleType: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly family: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly brand: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly material: string;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticleExport
     */
    weight?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticleExport
     */
    length?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticleExport
     */
    height?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticleExport
     */
    width?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticleExport
     */
    volume?: APIMeasurement | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly barcodeText: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly barcodeType: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly countryOfOrigin: string;
    /**
     * 
     * @type {APIHumanReadableDuration}
     * @memberof APIArticleExport
     */
    leadTime?: APIHumanReadableDuration | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleExport
     */
    readonly description: string;
}

/**
 * Check if a given object implements the APIArticleExport interface.
 */
export function instanceOfAPIArticleExport(value: object): value is APIArticleExport {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('articleType' in value) || value['articleType'] === undefined) return false;
    if (!('family' in value) || value['family'] === undefined) return false;
    if (!('brand' in value) || value['brand'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    if (!('barcodeText' in value) || value['barcodeText'] === undefined) return false;
    if (!('barcodeType' in value) || value['barcodeType'] === undefined) return false;
    if (!('countryOfOrigin' in value) || value['countryOfOrigin'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function APIArticleExportFromJSON(json: any): APIArticleExport {
    return APIArticleExportFromJSONTyped(json, false);
}

export function APIArticleExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleExport {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'number': json['number'],
        'articleType': json['article_type'],
        'family': json['family'],
        'brand': json['brand'],
        'material': json['material'],
        'weight': json['weight'] == null ? undefined : APIMeasurementFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementFromJSON(json['length']),
        'height': json['height'] == null ? undefined : APIMeasurementFromJSON(json['height']),
        'width': json['width'] == null ? undefined : APIMeasurementFromJSON(json['width']),
        'volume': json['volume'] == null ? undefined : APIMeasurementFromJSON(json['volume']),
        'barcodeText': json['barcode_text'],
        'barcodeType': json['barcode_type'],
        'countryOfOrigin': json['country_of_origin'],
        'leadTime': json['lead_time'] == null ? undefined : APIHumanReadableDurationFromJSON(json['lead_time']),
        'description': json['description'],
    };
}

export function APIArticleExportToJSON(value?: Omit<APIArticleExport, 'name'|'number'|'article_type'|'family'|'brand'|'material'|'barcode_text'|'barcode_type'|'country_of_origin'|'description'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'weight': APIMeasurementToJSON(value['weight']),
        'length': APIMeasurementToJSON(value['length']),
        'height': APIMeasurementToJSON(value['height']),
        'width': APIMeasurementToJSON(value['width']),
        'volume': APIMeasurementToJSON(value['volume']),
        'lead_time': APIHumanReadableDurationToJSON(value['leadTime']),
    };
}

